export const CONTABILIDAD_ROUTES = {
  RESUMEN:              '/contabilidad',
  MOVIMIENTOS:          '/contabilidad/movimientos',
  COBROS_PENDIENTES:    '/contabilidad/cobros-pendientes',
  EGRESOS_PENDIENTES:   '/contabilidad/egresos-pendientes',
  AGRUPADORES:          '/contabilidad/agrupadores',
  UTILIDAD:             '/contabilidad/utilidad',
  SOCIOS:               '/contabilidad/socios',
  CAJAS:                '/contabilidad/cajas',
} as const;
